<script>
	import {
		defineComponent
	} from 'vue'
	import headNav from "../components/headNav.vue";
	import {
		ArticleDetail,
		ArticleList,
		getMyMes
	} from "../api/api";
	import {
		mapGetters
	} from "vuex";

	export default defineComponent({
		name: "message",
		components: {
			headNav
		},
		computed: {
			...mapGetters(['userInfo'])
		},
		data() {
			return {
				page: 1,
				total: null,
				dataList: [],
				items: [],
				id: '',
				content: '',
				//根据id决定是否显示顶部图片
				ids: [14, 13, 12, 11, 10, 9, 8, 7, 6, 5, 4],
				seller: require('../../static/微信图片_20240626143134.jpg'),
				buyer: require('../../static/微信图片_20240626143134.jpg')

			}
		},
		// beforeRouteEnter(to, from, next) {
		// 	next(vm => {
		// 		// 在当前组件实例被创建后，调用 vm.fetchData 方法获取数据
		// 		vm.id = vm.$route.query.id
		// 		vm.getMes();
		// 	});
		// },
		// 使用 router.beforeEach 导航守卫来处理页面刷新
		// beforeRouteUpdate(to, from, next) {
		// 	// 当前路由变化，但是该组件被复用时，调用 vm.fetchData 方法获取数据
		// 	this.id = this.$route.query.id
		// 	this.getMes();
		// 	next();
		// },
		watch: {
			'$route'(to, from) {
				//刷新参数放到这里里面去触发就可以刷新相同界面了
				this.id = this.$route.query.id
				this.getMes()
			}
		},
		created() {
			console.log('created')
			this.id = this.$route.query.id
		},
		mounted() {
			console.log('mounted')
			this.getMes()
		},
		methods: {
			getMes() {
				ArticleDetail({
					id: this.id ? this.id :15
				}).then(res => {
					console.log(res, '打印res')
					this.content = res.data.data.details
				})
			},
			pageChange(e) {
				console.log(e)
				this.page = e
				this.getList()
			},
		}
	})
</script>

<template>
	<div>
		<div>
			<figure class="zoom-effect" style="margin-top: -60px;position: relative;">
				<div class="zoom-in"><img style="object-fit: cover;width: 100%;height: 300px;"
						:src="$route.query.id==4||$route.query.id==14?seller:buyer" alt="stories"
						class="lgpostImg img-fluid"></div>
				<figcaption
					style="position: absolute;left: calc(50% - 72px);top: calc(50% - 27px) ;color: #fff;font-size: 36px;">
					关于我们
				</figcaption>
			</figure>
		</div>
		<section id="blog-section" class="bg-light padding-large">
			<div class="container">
				<div v-html="content"></div>
			</div>
		</section>
	</div>
</template>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/view/about.vue